import Select from '../../../../juristec-ui/core/Select';

import {
  FirstPageContainer,
  SelectContainerFile,
  GridContainer,
  TypesContainer,
  TypeTooltip,
  ErrorMsg,
  HeaderTips,
} from './styled/SelectFile.styled';

import {
  Number, Letters, DateIcon,
} from '../../../../juristec-ui/icons';
import {
  Template,
  ColumnType,
  File,
} from '../types';

interface SelectFileProps {
  setSelectedFile: (file: File) => void;
  checkColumnsVar: () => boolean;
  files?: File[];
  selected?: Template;
  selectedFile?: File;
  fileColumns?: ColumnType;
}

interface LabelTypes {
  abc: string
  float: string
  date: string
}
const labelTypes: LabelTypes = {
  abc: 'Texto',
  float: 'Número',
  date: 'Data',
};

const labelIcons = {
  float: <Number />,
  abc: <Letters />,
  date: <DateIcon />,
} as const;

const genErrorMsg = (selected: Template, fileColumns: ColumnType): string => {
  const msg: string[] = [];
  (Object.keys(labelTypes)as Array<keyof typeof labelTypes>).forEach((cType) => {
    const size = selected.columnsType[cType]?.length || 0;
    const fSize = fileColumns[cType]?.length || 0;
    if (fSize < size) {
      msg.push(`${size} coluna${size > 1 ? 's' : ''} de ${labelTypes[cType].toUpperCase()}`);
    }
  });
  return ` ${msg.join(', ')}`;
};

/**
 * First step for the 'ApplyTemplate'. This is where the file is chosen.
 */
const FirstStep = ({
  setSelectedFile,
  checkColumnsVar,
  files = [],
  selected = {
    columnsType: {
      abc: [],
      float: [],
      date: [],
    },
    columnsRequired: {},
  },
  selectedFile = {
    label: '',
    value: '',
    filename: undefined,
  },
  fileColumns = {
    abc: [],
    float: [],
    date: [],
  },
}: SelectFileProps) => (
  <FirstPageContainer>
    <HeaderTips>
      Selecione abaixo o arquivo base para aplicar o template.
    </HeaderTips>
    <GridContainer>
      <SelectContainerFile>
        <Select
          placement="start"
          selectLabel="Arquivo"
          options={files.map((f) => ({
            ...f,
            id: f.file_id,
            value: f.file_id,
            label: f.filename!.replace('.metrics', ''),
          }))}
          // @ts-expect-error not typed yet
          value={selectedFile}
          // @ts-expect-error not typed yet
          onChange={setSelectedFile}
          placeholder="Selecione o arquivo"
          alphabeticalOrder
          isSearchable
          fullWidth
          atModal
        />
      </SelectContainerFile>
      <TypesContainer>
        {(Object.keys(labelTypes) as Array<keyof typeof labelTypes>).map((cType) => {
          const size = selected.columnsType[cType]?.length || 0;
          const fSize = fileColumns[cType]?.length || 0;
          if (size < 0) return null;
          return (
            <TypeTooltip
              atModal
              key={cType}
              direction="top"
              // @ts-expect-error not typed yet
              typeLabel={cType}
              isLess={fSize < size}
              text={`
                ${fSize} coluna${fSize > 1 ? 's' : ''} de ${labelTypes[cType].toUpperCase()} (${size} necessária${size > 1 ? 's' : ''})
              `}
            >
              <div>
                {labelIcons[cType]}
              </div>
              <h4>{`${fSize}/${size}`}</h4>
            </TypeTooltip>
          );
        })}
      </TypesContainer>
    </GridContainer>
    {!checkColumnsVar() && selectedFile?.value && selectedFile.value.length > 0 && (
      <ErrorMsg>
        Este template necessita de um arquivo com no mínimo
        <b>{genErrorMsg(selected, fileColumns)}</b>
      </ErrorMsg>
    )}
  </FirstPageContainer>
);

export default FirstStep;
